import React from 'react';

const CareerCTASection = () => {
    return (
        <section className="w-full bg-[#F0F0F0] overflow-hidden select-none">
            <div className="max-w-[1440px] w-full mx-auto grid grid-cols-1 md:grid-cols-2 items-stretch min-h-[340px]">

                <div className="w-full h-full min-h-[260px] md:min-h-auto relative">
                    <img
                        src="/assets/transforming/img9.png"
                        alt="Talent Search Visual"
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                </div>

                <div className="w-full bg-[#F0F0F0] py-12 md:py-16 px-6 sm:px-12 lg:px-20 xl:px-24 flex flex-col justify-center items-start text-left">
                    <div className="max-w-[480px] w-full flex flex-col gap-8">
                        <h2 className="text-[#01386A] font-sora font-[600] text-[20px] max-w-[389px] lg:text-[30px] leading-[1.25] tracking-tight">
                            We are always searching for the best talent
                        </h2>

                        <div>
                            <a
                                href="/careers"
                                className="group inline-flex items-center gap-2.5 font-graphik text-[14px] lg:text-[16px] font-[500] text-[#01386A] border-b-2 border-[#0A2540]/20 pb-1 hover:border-[#ED7A3A] transition-all duration-300"
                            >
                                <span>View All Global Openings</span>
                                <span className="text-[#ED7A3A] transition-transform duration-300 group-hover:translate-x-1">
                                    ➔
                                </span>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default CareerCTASection;